// --- Función de evaluación ---
/*const EvaluarRespuestas = (respuestas) => {
  // Puntajes iniciales
  let scores = {
    flexografia: 0,
    digital: 0,
    mangas: 0,
    iml: 0,
    termoformado: 0,
  };

  respuestas.forEach((resp, i) => {
    switch (i) {
      case 0: // Pregunta 1
        if (resp.includes("Botellas")) {
          scores.flexografia += 2;
          scores.digital += 2;
        } else if (resp.includes("Vasos")) {
          scores.iml += 3;
        } else if (resp.includes("Empaque")) {
          scores.termoformado += 3;
        } else if (resp.includes("variado")) {
          scores.digital += 3;
        }
        break;

      case 1: // Pregunta 2
        if (resp.includes("Más de 100,000")) {
          scores.flexografia += 3;
          scores.termoformado += 2;
        } else if (resp.includes("Entre 10,000")) {
          scores.flexografia += 2;
          scores.digital += 2;
        } else if (resp.includes("Menos de 10,000")) {
          scores.digital += 3;
        }
        break;

      case 2: // Pregunta 3
        if (resp.includes("personalización")) {
          scores.digital += 3;
          scores.mangas += 1;
        } else if (resp.includes("iguales")) {
          scores.flexografia += 2;
          scores.termoformado += 1;
          scores.iml += 1;
        }
        break;

      case 3: // Pregunta 4
        if (resp.includes("Sí")) {
          scores.flexografia += 2;
          scores.digital += 2;
          scores.iml += 1;
        } else if (resp.includes("No")) {
          scores.termoformado += 1;
          scores.iml += 1;
        }
        break;

      case 4: // Pregunta 5
        if (resp.includes("alimenticio")) {
          scores.iml += 3;
          scores.termoformado += 3;
        } else if (resp.includes("industria")) {
          scores.flexografia += 1;
          scores.digital += 1;
          scores.mangas += 1;
        }
        break;

      default:
        break;
    }
  });

  // Regla especial: cobertura completa
  if (respuestas.some((r) => r && r.toLowerCase().includes("cobertura completa"))) {
    scores.mangas += 5;
  }

  // Encontrar máximo
  const maxScore = Math.max(...Object.values(scores));
  const ganadores = Object.entries(scores)
    .filter(([_, score]) => score === maxScore)
    .map(([tec]) => tec);

  // Resolver empates con prioridad
  const prioridad = ["flexografia", "digital", "iml", "termoformado", "mangas"];
  const ganador = prioridad.find((tec) => ganadores.includes(tec));

  // Retornar nombre completo
  switch (ganador) {
    case "flexografia":
      return "Flexografía";
    case "digital":
      return "Digital Híbrida";
    case "mangas":
      return "Mangas Termoencogibles";
    case "iml":
      return "IML (In-Mold Labeling - inyección)";
    case "termoformado":
      return "Termoformado Automático (con o sin IML)";
    default:
      return "No se pudo determinar la mejor tecnología";
  }
};

export default EvaluarRespuestas;*/
// EvaluarRespuestas.js

// Función de evaluación
const evaluarRespuestas = (respuestas) => {
  const allAnswered = respuestas.every(r => r && r.toString().trim() !== "");
  if (!allAnswered) {
    return { key: null, nombre: null, scores: null };
  }

  const scores = {
    flexografia: 0,
    digital: 0,
    mangas: 0,
    iml: 0,
    termoformado: 0,
  };

  respuestas.forEach((resp, i) => {
    const r = (resp || "").toString().toLowerCase();

    switch (i) {
      case 0:
        if (r.includes("botellas")) {
          scores.flexografia += 2;
          scores.digital += 2;
        } else if (r.includes("vasos")) {
          scores.iml += 3;
        } else if (r.includes("empaque")) {
          scores.termoformado += 3;
        } else if (r.includes("variado")) {
          scores.digital += 3;
        }
        break;
      case 1: // Pregunta 2
        if (resp.includes("Más de 100,000")) {
          scores.flexografia += 3;
          scores.termoformado += 2;
        } else if (resp.includes("Entre 10,000")) {
          scores.flexografia += 2;
          scores.digital += 2;
        } else if (resp.includes("Menos de 10,000")) {
          scores.digital += 3;
        }
        break;

      case 2: // Pregunta 3
        if (resp.includes("personalización")) {
          scores.digital += 3;
          scores.mangas += 1;
        } else if (resp.includes("iguales")) {
          scores.flexografia += 2;
          scores.termoformado += 1;
          scores.iml += 1;
        }
        break;

      case 3: // Pregunta 4
        if (resp.includes("Sí")) {
          scores.flexografia += 2;
          scores.digital += 2;
          scores.iml += 1;
        } else if (resp.includes("No")) {
          scores.termoformado += 1;
          scores.iml += 1;
        }
        break;

      case 4: // Pregunta 5
        if (resp.includes("alimenticio")) {
          scores.iml += 3;
          scores.termoformado += 3;
        } else if (resp.includes("industria")) {
          scores.flexografia += 1;
          scores.digital += 1;
          scores.mangas += 1;
        }
        break;
        
      default:
        break;
    }
  });

  if (respuestas.some(r => r && r.toString().toLowerCase().includes("cobertura"))) {
    scores.mangas += 5;
  }

  const maxScore = Math.max(...Object.values(scores));
  const winners = Object.keys(scores).filter(k => scores[k] === maxScore);

  const prioridad = ["flexografia", "digital", "iml", "termoformado", "mangas"];
  const ganadorKey = prioridad.find(k => winners.includes(k));

  const nombreMap = {
    flexografia: "Flexografía",
    digital: "Digital Híbrida",
    mangas: "Mangas Termoencogibles",
    iml: "IML (In-Mold Labeling - inyección)",
    termoformado: "Termoformado Automático (con o sin IML)",
  };

  return {
    key: ganadorKey || null,
    nombre: ganadorKey ? nombreMap[ganadorKey] : null,
    scores,
  };
};

// exportar como default
export default evaluarRespuestas;

